<template>
  <div>
    <tab-bar currentActive="settings" @changeActive="changeTabbar"></tab-bar>
    <div class="container-fluid">
      <div class="row mt-5">
        <div class="col">
          <div class="position-relative w-100">
            <div class="position-absolute" style="z-index: 2000; top: -30px; right: 10px">
              <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
                @click="$router.push('/settings').catch(err => { })" style="width: 30px; height: 30px; min-height: 0">
                <icon width="20" height="20" name="times"></icon>
              </div>
            </div>
          </div>
          <h1>PRÉFÉRENCES</h1>
          <h2>GÉRER VOS DONNÉES PAR DÉFAUT</h2>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <!-- <div class="d-flex align-items-center justify-content-between">
            <div>
              <img src="/images/loic-droite.png" alt=""
                style="width: 60px; height: 60px; object-fit: cover; border-radius: 50%; background-color: rgb(242, 195, 74)" />
            </div>
            <div>
              <button class="btn btn-secondary btn-sm d-flex align-items-center justify-content-center"
                @click.stop="itemclick(item)"
                style="height: 30px; padding: 0 10px; font-size: 0.8rem; line-height: 0.8rem">
                <icon width="16" height="16" name="eye" class="mr-1"></icon>
                Modifier
              </button>
            </div>
          </div> -->
          <div class="d-flex justify-content-between mt-3">
            <div>
              <strong>{{ this.$store.state.user.co_firstname }} <span class="uppercase">{{
                this.$store.state.user.co_name }}</span></strong><br />
              Email : {{ $store.state.user.co_email }}<br />
              Tél : {{ $store.state.user.co_phone_mobile }}<br />
            </div>
            <div>
              <button class="btn btn-secondary btn-sm d-flex align-items-center justify-content-center"
                @click.stop="loadContact()"
                style="height: 30px; padding: 0 10px; font-size: 0.8rem; line-height: 0.8rem">
                <icon width="16" height="16" name="eye" class="mr-1"></icon>
                Modifier
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex justify-content-between">
            <div>
              <strong>Mon cotyle par défaut</strong><br />
              <div v-if="defaultProduct.cotyle">
                {{ defaultProduct.cotyle.pr_model }} {{ defaultProduct.cotyle.pr_subtype }}<br />
                Mat. {{ defaultProduct.cotyle.pr_matiere }}<br>
                Diam. {{ defaultProduct.cotyle.pr_size }} mm</div>
            </div>
            <div>
              <button class="btn btn-secondary btn-sm d-flex align-items-center justify-content-center"
                @click.stop="openCotyle()"
                style="height: 30px; padding: 0 10px; font-size: 0.8rem; line-height: 0.8rem">
                <icon width="16" height="16" name="eye" class="mr-1"></icon>
                Modifier
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex justify-content-between">
            <div>
              <strong>Ma tige par défaut</strong><br />
              <div v-if="defaultProduct.cotyle">
                {{ defaultProduct.tige.pr_model }} {{ defaultProduct.tige.pr_subtype }}<br />
                Mat. {{ defaultProduct.tige.pr_matiere }}<br>
                Taille {{ defaultProduct.tige.pr_size }} mm
              </div>
            </div>
            <div>
              <button class="btn btn-secondary btn-sm d-flex align-items-center justify-content-center"
                @click.stop="openTige" style="height: 30px; padding: 0 10px; font-size: 0.8rem; line-height: 0.8rem">
                <icon width="16" height="16" name="eye" class="mr-1"></icon>
                Modifier
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex justify-content-between">
            <div>
              <strong>Bille par défaut</strong><br />
              6mm
            </div>
            <div>
              <button class="btn btn-secondary btn-sm d-flex align-items-center justify-content-center"
                @click.stop="openBille" style="height: 30px; padding: 0 10px; font-size: 0.8rem; line-height: 0.8rem">
                <icon width="16" height="16" name="eye" class="mr-1"></icon>
                Modifier
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="helpwin" v-if="persowin">
      <div class="winclose">
        <a href="javascript:void(0);" @click="persowin = false">
          <icon width="24" height="24" name="times" class="" color="black"></icon>
        </a>
      </div>
      <div class="row">
        <div class="col-md-8">
          <h3>Données personnelles</h3>
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0" for="civility">Civilité</label>
              <select class="custom-select" style="height: 30px" v-model="contact.co_civility" id="civility">
                <option value="Mme">Madame</option>
                <option value="M">Monsieur</option>
                <option value="Dr.">Docteur</option>
                <option value="Prof.">Prof.</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <m-form-text label="Nom" v-model="contact.co_name" name="name"></m-form-text>
            </div>
            <div class="col-md-6">
              <m-form-text label="Prénom" v-model="contact.co_firstname" name="firstname"></m-form-text>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <m-form-text label="Email" v-model="contact.co_email" name="email"></m-form-text>
            </div>
            <div class="col-md-6">
              <m-form-text label="Téléphone" v-model="contact.co_phone_mobile" name="phone"></m-form-text>
            </div>
          </div>
          <!-- <div>
            <m-form-password :showRules="true" valid="shadow" :rules="rulesPassword"
              @validPassword="validPassword"></m-form-password>
          </div> -->

          <div class="row mt-2">
            <div class="col-md-12 d-flex flex-column">
              <button class="btn btn-primary mt-2" style="width: fit-content" @click="savePerso()">Enregistrer</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="helpwin" v-if="cotylewin">
      <div class="winclose">
        <a href="javascript:void(0);" @click="cotylewin = false">
          <icon width="24" height="24" name="times" class="" color="black"></icon>
        </a>
      </div>
      <div class="row">
        <div class="col-md-8">
          <h1>Cotyle</h1>
          <h2>Par défaut</h2>
          <div class="d-flex">
            <!-- <div> -->
            <!-- <select class="custom-select mt-2" v-model="cotyle_subtype"
                @change="changeSelectProduct('cotyle', 'subtype')">
                <option v-for="option in items_cotyle_subtype" :value="option.key" :key="option.key">
                  {{ option.name }}
                </option>
              </select> -->
            <!-- <select class="custom-select mt-2" v-model="cotyle_col" @change="changeSelectProduct('cotyle', 'col')">
                <option v-for="option in items_cotyle_col" :value="option.key" :key="option.key">
                  {{ option.name.replace(/\_PE/g, " Polyéthylène").replace(/\_Ceram/g, " Céramique") }}
                </option>
              </select> -->
            <!-- </div> -->
            <div class="flex-grow-1">
              <div class="tabber mb-3">
                <label class="label-subtype label-G ml-2" for="subtypeg">Fixe</label>
                <input type="radio" v-model="cotyle_subtype" name="subtype" id="subtypeg" value="FIXE"
                  @change="changeSelectProduct('cotyle', 'subtype')" />
                <label class="label-subtype label-D ml-4" for="subtyped">Mobile</label>
                <input type="radio" v-model="cotyle_subtype" name="subtype" id="subtyped" value="MOBILE"
                  @change="changeSelectProduct('cotyle', 'subtype')" />
                <div class="blob"></div>
              </div>

              <div class="tabber">
                <label class="label-insert label-G ml-2" for="insertg">Céramique</label>
                <input type="radio" v-model="cotyle_insert" name="insert" id="insertg" value="Céramique"
                  @change="changeSelectProduct('cotyle', 'insert')" />
                <label class="label-insert label-D ml-4" for="insertd">Polyéthylène</label>
                <input type="radio" v-model="cotyle_insert" name="insert" id="insertd" value="Polyéthylène"
                  @change="changeSelectProduct('cotyle', 'insert')" />
                <div class="blob"></div>
              </div>
            </div>

            <div class="d-flex ml-4 justify-content-between align-items-center">
              <div class="text-center text-nowrap mr-2" style="font-size: 2rem">
                Ø {{ cotyle_productSelected ? cotyle_productSelected.pr_size : "" }}
              </div>
              <div class="">
                <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
                  :class="{ disabled: getClassGray2('plus', 'cotyle', true) }"
                  @click="changeSelectProduct('cotyle', 'size', 'plus')"
                  style="width: 30px; height: 30px; min-height: 0">
                  <icon width="20" height="20" name="chevron-up"></icon>
                </div>
                <div class="mt-2 rounded-circle d-flex align-items-center justify-content-center btn-icon"
                  :class="{ disabled: getClassGray2('moins', 'cotyle', true) }"
                  @click="changeSelectProduct('cotyle', 'size', 'moins')"
                  style="width: 30px; height: 30px; min-height: 0">
                  <icon width="20" height="20" name="chevron-down"></icon>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 d-flex flex-column">
              <button class="btn btn-primary mt-2" style="width: fit-content" @click="savePerso()">Enregistrer</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="helpwin" v-if="tigewin">
      <div class="winclose">
        <a href="javascript:void(0);" @click="tigewin = false">
          <icon width="24" height="24" name="times" class="" color="black"></icon>
        </a>
      </div>
      <div class="row">
        <div class="col-md-8">
          <h1>Cotyle</h1>
          <h2>Par défaut</h2>
          <div class="d-flex">
            <!-- <div>
              <select class="custom-select my-2" v-model="tige_subtype"
                @change="changeSelectProduct('tige', 'subtype')">
                <option v-for="option in items_tige_subtype" :value="option.key" :key="option.key">
                  {{ option.name }}
                </option>
              </select>
              <select class="custom-select" v-model="tige_col" @change="changeSelectProduct('tige', 'col')">
                <option v-for="option in items_tige_col" :value="option.key" :key="option.key">
                  {{
                    option.name
                      .replace(/\_Inox/g, " Inox")
                      .replace(/\_Ceram/g, " Céramique")
                      .replace(/\_CrCo/g, " Chrome Cobalt")
                  }}
                </option>
              </select>
            </div> -->
            <div class="flex-grow-1">
              <select class="custom-select my-2" v-model="tige_subtype"
                @change="changeSelectProduct('tige', 'subtype')">
                <option v-for="option in items_tige_subtype" :value="option.key" :key="option.key">
                  {{ option.name }}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between align-items-center ml-3">
              <div class="text-nowrap mr-2" style="font-size: 2rem">Ø {{ tige_productSelected ?
                tige_productSelected.pr_size : "" }}</div>
              <div>
                <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
                  :class="{ disabled: getClassGray2('plus', 'tige', true) }"
                  @click="changeSelectProduct('tige', 'size', 'plus')" style="width: 30px; height: 30px; min-height: 0">
                  <icon width="20" height="20" name="chevron-up"></icon>
                </div>
                <div class="mt-2 rounded-circle d-flex align-items-center justify-content-center btn-icon"
                  :class="{ disabled: getClassGray2('moins', 'tige', true) }"
                  @click="changeSelectProduct('tige', 'size', 'moins')"
                  style="width: 30px; height: 30px; min-height: 0">
                  <icon width="20" height="20" name="chevron-down"></icon>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 d-flex flex-column">
              <button class="btn btn-primary mt-2" style="width: fit-content" @click="savePerso()">Enregistrer</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="helpwin" v-if="billewin">
      <div class="winclose">
        <a href="javascript:void(0);" @click="billewin = false">
          <icon width="24" height="24" name="times" class="" color="black"></icon>
        </a>
      </div>
      <div class="row">
        <div class="col-md-8">
          <h1>Bille</h1>
          <h2>Par défaut</h2>
          <div class="row">
            <div class="col-md-6">
              <m-form-text label="Taille de la bille (mm)" v-model="bille" name="bille"></m-form-text>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-12 d-flex flex-column">
              <button class="btn btn-primary mt-2" style="width: fit-content" @click="savePerso()">Enregistrer</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
import { version } from "../../package.json";

export default {
  name: "home-settings",
  components: {},
  data() {
    return {
      notdisplayanymore: false,
      version,
      persowin: false,
      cotylewin: false,
      tigewin: false,
      billewin: false,
      contact: this.$store.state.user,
      rulesPassword: {
        nbCharacteres: 8,
        specialCharactere: true,
        uppercase: true,
        number: true
      },
      bille: 6,
      isValidPassword: false,
      errPassword: [],

      productsTree: [],
      cotyle_productSelected: null,
      tige_productSelected: null,

      items_cotyle_model: [],
      items_cotyle_subtype: [],
      items_cotyle_col: [],
      items_cotyle_size: [],
      cotyle_model: "",
      cotyle_subtype: "",
      cotyle_col: "",
      cotyle_insert: "",
      cotyle_size: 0,

      items_tige_model: [],
      items_tige_subtype: [{ key: "Standard", name: "Standard" }, { key: "High Offset", name: "High Offset" }, { key: "Coxa Vara", name: "Coxa Vara" }],
      items_tige_col: [],
      items_tige_size: [],
      tige_model: "",
      tige_subtype: "",
      tige_col: "",
      tige_size: 0,

      defaultProduct: {
        cotyle: null,
        tige: null
      }
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    // console.log("this.$route.path", this.$route.path);
    this.$store.dispatch("addHistoryUrl", this.$route.path);
    // this.loadPatients();
    await this.loadTree();
    await this.loadDefaultProduct();
    await this.$store.dispatch("setversion");
  },
  watch: {},
  computed: {},
  methods: {
    async savePerso() {
      let products = {
        pr_id_cotyle: this.cotyle_productSelected.pr_id,
        pr_id_tige: this.tige_productSelected.pr_id,
        co_name: this.contact.co_name,
        co_firstname: this.contact.co_firstname,
        co_email: this.contact.co_email,
        co_phone_mobile: this.contact.co_phone_mobile,
        co_civility: this.contact.co_civility
        // co_ballsize: this.patient.pa_toolsballsize
      };
      this.defaultProduct = {
        cotyle: this.cotyle_productSelected,
        tige: this.tige_productSelected
      };
      await this.$axios.put(this.$config.server_url + "/api/1.0/contacts/" + this.$store.state.user.co_id + "/preferences", products);
      this.persowin = false;
      this.cotylewin = false;
      this.tigewin = false;
      this.billewin = false;
    },
    loadContact() {
      // this.contact = this.$store.state.user;
      // console.log("🚀 ~ loadContact ~ this.contact:", this.contact);
      this.persowin = true;
    },
    async openCotyle() {
      // await this.loadTree();
      // await this.loadDefaultProduct();
      this.cotylewin = true;
    },
    async openTige() {
      // await this.loadTree();
      // await this.loadDefaultProduct();
      this.tigewin = true;
    },
    async openBille() {
      this.billewin = true;
    },
    validPassword(isValid, errors, password) {
      this.isValidPassword = isValid;
      this.errPassword = errors;
      this.co_password1 = password;
    },
    gotoPerso() {
      this.$router.push("/settings/perso").catch(err => {});
    },
    changeTabbar(where) {
      if (where == "patients") {
        this.showPassed = false;
      }
    },
    reloadApp() {
      window.location.reload();
    },
    defineVmodelSelectProduct(product) {
      // define les v model
      this[product.pr_type + "_productSelected"] = product;
      this[product.pr_type + "_subtype"] = product.pr_subtype;
      this[product.pr_type + "_insert"] = product.pr_insert;
      this[product.pr_type + "_size"] = product.pr_size;
    },
    async loadDefaultProduct() {
      // console.log("loadDefaultProduct");
      let response = await this.$axios.get(this.$config.server_url + "/api/1.0/productsdefault");
      this.defineVmodelSelectProduct(response.data.data.tige);
      this.defineVmodelSelectProduct(response.data.data.cotyle);
      // this.defineSelectProduct("cotyle");
      // this.defineSelectProduct("tige");
      // console.log("response.data.data.tige", response.data.data.tige);
      this.defaultProduct = {
        cotyle: response.data.data.cotyle,
        tige: response.data.data.tige
      };
    },
    async loadTree() {
      // route qui récupère tous les produits triés par models, subtype, col et size  sous forme d'arbre
      let response = await this.$axios.get(this.$config.server_url + "/api/1.0/products/tree", {
        params: {}
      });
      this.productsTree = response.data.data;
    },
    defineSelectProduct(type, sizeSelected = null) {
      return;
      // console.log("type, sizeSelected", type, sizeSelected, this.tige_productSelected);
      let index = 0;
      if (type === "tige") index = 1;

      this.items_cotyle_model = this.productsTree[0].items;
      this.items_tige_model = this.productsTree[1].items;
      for (let m = 0; m < this.productsTree[index].items.length; m++) {
        const model = this.productsTree[index].items[m];
        // on definie les items subtype en tournant des les models et en trouvant le model sélectionné
        if (this[type + "_model"] && this[type + "_model"].toLowerCase() === model.key.toLowerCase()) {
          this["items_" + type + "_subtype"] = model.items;
          for (let s = 0; s < model.items.length; s++) {
            const subtype = model.items[s];
            if ((this[type + "_subtype"] && this[type + "_subtype"].toLowerCase() === subtype.key.toLowerCase()) || this[type + "_subtype"] == null) {
              if (this[type + "_subtype"] == null) this[type + "_subtype"] = subtype.key;
              // if (type == "cotyle") {
              //   this["items_" + type + "_size"] = subtype.items;
              //   for (let d = 0; d < subtype.items.length; d++) {
              //     const size = subtype.items[d];
              //     if (this.cotyle_productSelected == null && !sizeSelected) {
              //       this.cotyle_productSelected = size.product;
              //     }
              //     if (this.cotyle_productSelected == null && sizeSelected && sizeSelected === size.key) {
              //       this.cotyle_productSelected = size.product;
              //     }
              //   }
              //   if (!this.cotyle_productSelected) this.cotyle_productSelected = subtype.items[0].product;
              // }
              // if (type === "tige") {
              this["items_" + type + "_col"] = subtype.items;
              for (let c = 0; c < subtype.items.length; c++) {
                const col = subtype.items[c];
                if ((this[type + "_col"] && this[type + "_col"].toLowerCase() === col.key.toLowerCase()) || this[type + "_col"] == null) {
                  if (this[type + "_col"] == null) this[type + "_col"] = col.key;
                  this["items_" + type + "_size"] = col.items;
                  for (let d = 0; d < col.items.length; d++) {
                    const size = col.items[d];
                    if (this[type + "_productSelected"] == null && !sizeSelected) {
                      this[type + "_productSelected"] = size.product;
                    }
                    if (this[type + "_productSelected"] == null && sizeSelected && sizeSelected === size.key) {
                      this[type + "_productSelected"] = size.product;
                    }
                  }
                  if (!this[type + "_productSelected"]) {
                    this[type + "_productSelected"] = col.items[0].product;
                  }
                }
              }
              // }
            }
          }
        }
        console.log("this.cotyle_productSelected", this.cotyle_productSelected);
        console.log("this.tige_productSelected", this.tige_productSelected);
      }
      this.items_cotyle_col.sort((a, b) => {
        if (a.key.includes("_PE") && b.key.includes("_PE")) return a.key.localeCompare(b.key);
        if (a.key.includes("_Ceram") && b.key.includes("_Ceram")) return a.key.localeCompare(b.key);
        if (a.key.includes("_PE")) return 1;
        if (a.key.includes("_Ceram")) return -1;
        return 0;
      });
      this.items_tige_col.sort((a, b) => {
        let spa = a.key.split("_");
        let spb = b.key.split("_");
        if (spa[1] == spb[1]) return spa[0].localeCompare(spb[0]);
        return spa[1].localeCompare(spb[1]);
      });
      // console.log('this[type + "_col"]', type, this[type + "_col"]);
    },
    getClassGray2(sens, type, mobile = false) {
      // "#c6091f" => rouge vif , #d6979e=> rouge disabled
      if (!this[type + "_productSelected"]) {
        // console.log("getClassGray2", "is not selected");
        return true;
      }
      if (type === "cotyle") {
        let allCotyleSizes = this.productsTree.filter(p => p.pr_type === "cotyle" && p.pr_subtype === this.cotyle_subtype && p.pr_insert === this.cotyle_insert);
        let indexSize = this.$_.findIndex(allCotyleSizes, { pr_size: this[type + "_productSelected"].pr_size });
        if (indexSize === 0 && sens === "moins") {
          return true;
        }
        if (indexSize === allCotyleSizes.length - 1 && sens === "plus") {
          return true;
        }
      }
      if (type === "tige" && this.cotyle_productSelected) {
        let allTigeSizes = this.productsTree.filter(p => p.pr_type === "tige" && p.pr_subtype === this.tige_subtype && p.pr_tete == this.cotyle_productSelected.pr_tete);
        let indexSize = this.$_.findIndex(allTigeSizes, { pr_size: this.tige_productSelected.pr_size });
        if (indexSize === 0 && sens === "moins") {
          return true;
        }
        if (indexSize === allTigeSizes.length - 1 && sens === "plus") {
          return true;
        }
      }
      return false;
    },

    // async changeSelectProduct(type, select, sens = "") {
    //   // console.log("this.tige_productSelected", this.tige_productSelected.pr_size);
    //   // on garde la taille en mémoire
    //   let size;
    //   if (this[type + "_productSelected"]) {
    //     size = this[type + "_productSelected"].pr_size;
    //   }
    //   // console.log("size", size);
    //   // on met les v-model à null et on appelle defineSelectProduct() pour redeffinir tous les selects
    //   if (select !== "size") {
    //     this[type + "_productSelected"] = null;
    //     if (select === "model") {
    //       this[type + "_subtype"] = null;
    //       // if (type === "tige") this.tige_col = null;
    //       this[type + "_col"] = null;
    //     }
    //     if (select === "subtype") {
    //       // && type === "tige"
    //       // this.tige_col = null;
    //       this[type + "_col"] = null;
    //     }
    //     this.defineSelectProduct(type, size);
    //   } else {
    //     this.defineSelectProduct(type, size);
    //     let indexSize = this.$_.findIndex(this["items_" + type + "_size"], { key: this[type + "_productSelected"].pr_size });
    //     if (indexSize >= 0) {
    //       if (sens === "plus" && indexSize < this["items_" + type + "_size"].length - 1) {
    //         this[type + "_productSelected"] = this["items_" + type + "_size"][indexSize + 1].product;
    //       }
    //       if (sens === "moins" && indexSize > 0) this[type + "_productSelected"] = this["items_" + type + "_size"][indexSize - 1].product;
    //     }
    //   }
    // }
    async changeSelectProduct(type, select, sens = "") {
      // console.log('type, select, sens, ', type, select, sens);
      // console.log("this.tige_productSelected", this.tige_productSelected.pr_size);
      // on garde la taille en mémoire
      // let size;
      // if (this[type + "_productSelected"]) {
      //   size = this[type + "_productSelected"].pr_size;
      // }
      if (type == "cotyle") {
        let allCotyleSizes = this.productsTree.filter(p => p.pr_type === "cotyle" && p.pr_subtype === this.cotyle_subtype && p.pr_insert === this.cotyle_insert);
        // console.log('allProductsSizes', allProductsSizes.length);
        allCotyleSizes.sort((a, b) => a.pr_size - b.pr_size);
        if (select === "size") {
          let indexSize = this.$_.findIndex(allCotyleSizes, { pr_size: this.cotyle_size });
          if (indexSize >= 0) {
            if (sens === "plus" && indexSize < allCotyleSizes.length - 1) {
              this.cotyle_size = allCotyleSizes[indexSize + 1].pr_size;
            }
            if (sens === "moins" && indexSize > 0) {
              this.cotyle_size = allCotyleSizes[indexSize - 1].pr_size;
            }
          }
        }
        if (this.cotyle_subtype == "MOBILE" && this.cotyle_insert == "Céramique") {
          await new Promise((resolve) => {
            setTimeout(() => {
              this.cotyle_insert = "Polyéthylène";
              resolve();
            }, 500);
          }).then(() => {
          });
        }
        let ps = this.productsTree.find(p => p.pr_type === "cotyle" && p.pr_subtype === this.cotyle_subtype && p.pr_insert === this.cotyle_insert && p.pr_size === this.cotyle_size);
        // si on ne trouve pas, on prend la premiere taille
        if (!ps) {
          ps = allCotyleSizes[0];
          this.cotyle_size = ps.pr_size;
        }
        this.cotyle_productSelected = ps;
        // console.log("🚀 ~ changeSelectProduct ~ ps:", ps.pr_ref)
        // console.log("this[type + '_productSelected']", this.cotyle_subtype, this.cotyle_insert, this.cotyle_size);
      }

      if (type == "tige" && this.cotyle_productSelected) {
        // console.log('this.tige_size, this.tige_subtype', this.tige_size, this.tige_subtype);
        let allTigeSizes = this.productsTree.filter(p => p.pr_type === "tige" && p.pr_subtype === this.tige_subtype && p.pr_tete == this.cotyle_productSelected.pr_tete);
        allTigeSizes.sort((a, b) => a.pr_size - b.pr_size);
        // console.log("🚀 ~ changeSelectProduct ~ allTigeSizes:", allTigeSizes)

        if (select === "size") {
          let indexSize = this.$_.findIndex(allTigeSizes, { pr_size: this.tige_size });
          if (indexSize >= 0) {
            if (sens === "plus" && indexSize < allTigeSizes.length - 1) {
              this.tige_size = allTigeSizes[indexSize + 1].pr_size;
            }
            if (sens === "moins" && indexSize > 0) {
              this.tige_size = allTigeSizes[indexSize - 1].pr_size;
            }
          }
        }

        let ps = this.productsTree.find(p => p.pr_type === "tige" && p.pr_subtype === this.tige_subtype && p.pr_tete == this.cotyle_productSelected.pr_tete && p.pr_size === this.tige_size);
        if (!ps) {
          ps = allTigeSizes[0];
          this.tige_size = ps.pr_size;
        }
        this.tige_productSelected = ps;
        // console.log("🚀 ~ changeSelectProduct ~ this.tige_productSelected:", this.tige_productSelected.pr_ref)
      }

      // console.log("size", size);
      // on met les v-model à null et on appelle defineSelectProduct() pour redeffinir tous les selects
      // if (select !== "size") {
      //   this[type + "_productSelected"] = null;
      //   if (select === "model") {
      //     this[type + "_subtype"] = null;
      //     // if (type === "tige") this.tige_col = null;
      //     this[type + "_col"] = null;
      //   }
      //   if (select === "subtype") {
      //     // && type === "tige"
      //     // this.tige_col = null;
      //     this[type + "_col"] = null;
      //   }
      //   this.defineSelectProduct(type, size);
      // } else {
      //   this.defineSelectProduct(type, size);
      //   let indexSize = this.$_.findIndex(this["items_" + type + "_size"], { key: this[type + "_productSelected"].pr_size });
      //   if (indexSize >= 0) {
      //     if (sens === "plus" && indexSize < this["items_" + type + "_size"].length - 1) {
      //       this[type + "_productSelected"] = this["items_" + type + "_size"][indexSize + 1].product;
      //     }
      //     if (sens === "moins" && indexSize > 0) this[type + "_productSelected"] = this["items_" + type + "_size"][indexSize - 1].product;
      //   }
      // }


    },

    // async loadPatients() {
    //   let limit = 30;
    //   let sort = this.sortFields.reduce((accumulator, field) => {
    //     if (accumulator) accumulator += ", ";
    //     accumulator += field + " " + this.sortOrder;
    //     return accumulator;
    //   }, "");
    //   if (this.archive) limit = 100000;
    //   let params = {
    //     pa_archive: this.archive,
    //     // text: this.filterText,
    //     sort: sort,
    //     limit: limit,
    //     pa_type: "hanche"
    //   };
    //   let response = await this.$axios.get(this.$config.server_url + "/api/1.0/patients", { params });
    //   this.patients_today = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isSame(this.$dayjs(), "day");
    //   });
    //   this.patients_tomorrow = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isSame(this.$dayjs().add(1, "day"), "day");
    //   });
    //   this.patients_future = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isAfter(this.$dayjs().add(1, "day"), "day");
    //   });
    //   this.patients_past_week = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isBetween(this.$dayjs().add(-7, "day"), this.$dayjs(), "day");
    //   });
    //   this.patients_past_month = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isBetween(this.$dayjs().add(-30, "day"), this.$dayjs().add(-7, "day"), "day");
    //   });
    //   this.patients_past_other = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isBefore(this.$dayjs().add(-30, "day"), "day");
    //   });
    //   // console.log("🚀 ~ loadPatients ~ this.patients:", this.patients);
    //   // this.patients = this.patients.filter(p => {
    //   //   if (!this.filterText) return true;
    //   //   if (p.pa_name.toLocaleLowerCase("fr").indexOf(this.filterText.toLocaleLowerCase("fr")) >= 0) return true;
    //   //   return false;
    //   // });
    //   // if (response.data.meta) this.patients_total = response.data.meta.total;
    //   // else this.patients_total = this.patients.length;
    // },
  }
};
</script>

<style scoped lang="scss">
.m-form-checkbox {
  margin-bottom: 0;
}

.cguwin {
  position: fixed;
  background-color: white;
  border: 1px solid black;
  top: 5%;
  height: 90%;
  width: 90%;
  left: 5%;
  z-index: 10001;
  padding: 20px;

  // overflow: auto;
  .btn-jaccepte {
    position: absolute;
    bottom: 5px;
  }
}

.cguwin-content {
  overflow: auto;
}

@media (min-width: 576px) {
  .helpwin {}
}

@media (min-width: 768px) {
  .helpwin {}
}

.h-100vh {
  height: 100vh;
}

.bg-blue2 {
  background-color: rgb(161, 173, 194);
}

.topwhite {
  background-color: white;
  border-radius: 20px;
  padding: 20px;
}

.buttonsettings {
  width: 100%;
  text-align: left;
  background-color: rgb(237, 236, 236);
  border-radius: 10px;
  color: rgb(12, 40, 56);
  padding: 20px;
}

.btn-icon {
  background-color: #c6091f;
  color: white;

  &.disabled {
    background-color: #a7a7a7;
  }
}


/*************** css switch droite / gauche **************** */
.tabber {
  cursor: pointer;
  width: 100%;
  height: 28px;
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  background-color: #c3c9d4;
  border: 1px solid #bababa;
  border-radius: 20px;
}

.tabber-mobile {
  color: #485057;
  background-color: #ffffff73;
}

.label-subtype {
  position: absolute;
  // padding: 0 20px;
  top: 2px;
  z-index: 10;
  margin-bottom: 0;
  transition: transform 125ms ease-in-out, filter 125ms ease-in-out;
}

.label-insert {
  position: absolute;
  // padding: 0 20px;
  top: 2px;
  z-index: 10;
  margin-bottom: 0;
  transition: transform 125ms ease-in-out, filter 125ms ease-in-out;
}

.label-G {
  // left: 8px;
  text-align: center;
  color: white;
  width: 50%;
}

.label-D {
  text-align: center;
  right: 0px;
  color: white;
  width: 50%;
}

input[type="radio"] {
  display: none;

  // static
  &#insertd~.blob,
  &#subtyped~.blob {
    transform-origin: right center;
  }

  &#insertg~.blob,
  &#subtypeg~.blob {
    transform-origin: left center;
  }

  // animated
  &#insertg:checked,
  &#subtypeg:checked {
    ~.blob {
      background: #c7081f;
      animation-name: stretchyRev;
    }
  }

  &#insertd:checked,
  &#subtyped:checked {
    ~.blob {
      background-color: #c7081f;
      animation-name: stretchy;
    }
  }
}

.blob {
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  position: absolute;
  z-index: 0;
  border-radius: 4rem;
  animation-duration: 0.5s;
  animation-direction: forwards;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  transition: transform 150ms ease;

  &:before,
  &:after {
    display: block;
    content: "";
    position: absolute;
    top: 0;
    background-color: inherit;
    height: 100%;
    width: 50%;
    border-radius: 100%;
    transition: transform 150ms ease;
    animation-name: pulse;
    animation-duration: 0.5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }

  &:before {
    left: 0;
    animation-delay: 0.15s;
  }

  &:after {
    right: 0;
  }
}

@keyframes stretchy {
  0% {
    transform: translateX(0) scaleX(1);
  }

  100% {
    transform: translateX(100%) scaleX(1);
  }
}

@keyframes stretchyRev {
  0% {
    transform: translateX(100%) scaleX(1);
  }

  100% {
    transform: translateX(0) scaleX(1);
  }
}
</style>
